import { render, staticRenderFns } from "./PuhuoTable.vue?vue&type=template&id=1c7ec350&scoped=true"
import script from "./PuhuoTable.vue?vue&type=script&lang=js"
export * from "./PuhuoTable.vue?vue&type=script&lang=js"
import style0 from "./PuhuoTable.vue?vue&type=style&index=0&id=1c7ec350&prod&lang=scss&scoped=true"
import style1 from "./PuhuoTable.vue?vue&type=style&index=1&id=1c7ec350&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7ec350",
  null
  
)

export default component.exports